import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "sr/helpers";
export const TaskManageButton = ({approveOnClick=null,  managetasks=null,  removeStatus = null, rejectOnClick=null, type=null, checkSupervisorStatus=null, CheckContractorComplete=null}) => {
  


  return (
  <div className="flex justify-center my-5">
{
    checkSupervisorStatus==='approved' && 
    <div className="flex space-x-3 justify-center items-center">
  <Button text={<FormattedMessage id= "SUPERVISOR.PENDING.JOB.APPROVED.BTN" defaultMessage="Approved" />} className={'bg-[#ff39b3] font-bold text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>
{type !== 'workorder' &&
<svg onClick={removeStatus} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 cursor-pointer">
  <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
}
</div>
}
{
   checkSupervisorStatus==='pending' &&
    <>
    <Button onClick={approveOnClick} text={<FormattedMessage id="SUPERVISOR.PENDING.JOB.APPROVE.BTN" defaultMessage="Approve" />} className={'bg-[#ff39b3] font-bold text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>
  
    <Button onClick={rejectOnClick} text={<FormattedMessage id="SUPERVISOR.PENDING.JOB.REJECT.BTN" defaultMessage="Reject" />} className={'bg-red-600	mx-5  text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>   
    </>
}
{
    checkSupervisorStatus==='rejected' &&
      <div className="flex space-x-3 justify-center items-center">
   <Button text={<FormattedMessage id="SUPERVISOR.PENDING.JOB.REJECTED.BTN" defaultMessage="Rejected" />} className={'bg-red-600	mx-5 text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>
   {type !== 'workorder' &&
   <svg onClick={removeStatus}  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 cursor-pointer">
  <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
}
</div>
   }
   {
    type==='workorder' && 
    <>
    <Button onClick={approveOnClick} text={<FormattedMessage id="SUPERVISOR.PENDING.JOB.APPROVE.BTN" defaultMessage="Approve" />} className={'bg-[#ff39b3] font-bold text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>
    { managetasks?.some((item)=> item?.supervisor_status==='rejected') &&
    <Button onClick={rejectOnClick} text={<FormattedMessage id="SUPERVISOR.PENDING.JOB.REJECT.BTN" defaultMessage="Reject" />} className={'bg-red-600	mx-5  text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>   
}
    </>
   }

      </div>);
};
